import Vuex from "vuex";

// user module
import auth from "@/store/userModule/auth";
import role from "@/store/userModule/role";
import user from '@/store/userModule/user';
// accounting module
import coa from "@/store/accountModule/coa";
import journal from "@/store/accountModule/journal";
import ledger from "@/store/accountModule/ledger";
import invoice from "@/store/accountModule/invoice";
// purchase module
import supplier from "@/store/purchaseModule/supplier";
import purchase from "@/store/purchaseModule/purchase";
// inventory module
import unit from "@/store/inventoryModule/unit";
import category from "@/store/inventoryModule/category";
import size from '@/store/inventoryModule/size';
import color from "@/store/inventoryModule/color";
import product from "@/store/inventoryModule/product";
import stock from "@/store/inventoryModule/stock";
// crm module
import customer from "@/store/crmModule/customer";
// sale moudle
import order from "@/store/saleModule/order";
// analytics module
import analyticsCustomer from "@/store/analyticsModule/customer";


export default new Vuex.Store({
  modules: {
    auth,
    role,
    user,
    coa,
    journal,
    ledger,
    invoice,
    supplier,
    purchase,
    unit,
    category,
    size,
    color,
    product,
    stock,
    customer,
    order,
    analyticsCustomer,
  },
});